<script lang="ts" setup>
import BtnPrevStepAssessment from '@Widgets/Assessment/BtnPrevStepAssessment.vue'
import { AppLogoDomain } from '@UI/Logos/AppLogoDomain'
import AssessmentCounter from '@Molecules/Assessment/AssessmentCounter.vue'

defineOptions({
  name: 'SectionAssessmentTestHeader',
})

</script>

<template>
  <div class="assessment-header">
    <BtnPrevStepAssessment />
    <AppLogoDomain />
    <AssessmentCounter />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Sections/Assessment/SectionAssessmentTestHeader.scss" />
